export function showsPageStationContext(path) {
  return path.startsWith('/naftapos/') || path === '/pts2/overview' || path === '/pts2/transactions'
    || path === '/pts2/tank-measurements' || path === '/pts2/alerts'
}

export function pageViewKey(route, session) {
  if (route.name === 'receipts') {
    return `receipts:${session.user?.id ?? session.user?.username ?? ''}:${session.user?.accessVersion ?? ''}`
  }
  if (['pts2-diagnostics', 'pts2-configuration-history', 'pts2-operator-tags', 'pts2-controllers', 'pts2-controller-detail', 'pts2-controller-settings',
    'pts2-controller-prices', 'pts2-price-operation'].includes(route.name)) {
    return `${route.fullPath}:${session.user?.id ?? ''}:${session.user?.accessVersion ?? ''}`
  }
  const sourceId = route.path.startsWith('/pts2/') ? '' : session.platformContext?.activeNaftaPosInstanceId
  if (route.name === 'access-users' || route.name === 'access-user-detail') return `access-users:${sourceId}`
  return `${route.fullPath}:${session.platformContext?.activeStationId ?? ''}:${sourceId ?? ''}`
}
